module.exports = __webpack_public_path__ + "img/ico_reload.e57bdc04.svg";